// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2X50y","container":"styles_container__3gO15","title":"styles_title__2xjer","wrapper":"styles_wrapper__2MpGy","answer":"styles_answer__3iNhy"};